import flow from 'lodash/flow';
import { mapImageUrlFromMsg, mapUserNameFromMsg } from './_mappers';

// Responses

export const normaliseParticipant = flow(
  mapImageUrlFromMsg,
  mapUserNameFromMsg
);
